import _ from 'lodash';
import moment from 'moment';
import { Firebase, callIfFunction, unwrapDoc, goalValueIsSet, unwrapDocs, logAndDispatchErrorForAction, withoutId, getCurrentTimestamp, accountId, organizationId, isProduction, omitDeleted, addKeysAsIds } from './../util';
import { OrganizationRef, TalentEvaluationsRef } from './../util/refs';

import {
  FETCH_TALENT_EVALUATIONS,
  FETCH_TALENT_EVALUATIONS_SUCCESS,
  FETCH_TALENT_EVALUATIONS_ERROR,

  SAVE_TALENT_EVALUATION,
  SAVE_TALENT_EVALUATION_SUCCESS,
  SAVE_TALENT_EVALUATION_ERROR,

} from './types';

export function saveTalentEvaluation(employeeId, talentEvaluationData, callback){
  console.log('saving talent card for user: ', employeeId);

  return dispatch => {

    dispatch({
      type: SAVE_TALENT_EVALUATION,
    });

    TalentEvaluationsRef().add(talentEvaluationData).then(docRef => {

      const talentEvaluationDataWithId = {
        ...talentEvaluationData,
        _id: docRef.id
      };

      dispatch({
        type: SAVE_TALENT_EVALUATION_SUCCESS,
        payload: talentEvaluationDataWithId
      });

      callIfFunction(callback, talentEvaluationDataWithId);

    }).catch(err => { logAndDispatchErrorForAction(`Save new talent evaluation for user ${employeeId}`, err, dispatch, SAVE_TALENT_EVALUATION_ERROR, callback) });
  }
}

export function updateTalentEvaluation(employeeId, talentEvaluationData, callback){
  console.log('saving talent card for user: ', employeeId);

  return dispatch => {

    dispatch({
      type: SAVE_TALENT_EVALUATION,
    });

    TalentEvaluationsRef().doc(talentEvaluationData._id).set(talentEvaluationData).then(docRef => {

      dispatch({
        type: SAVE_TALENT_EVALUATION_SUCCESS,
        payload: talentEvaluationData
      });

      callIfFunction(callback, talentEvaluationData);

    }).catch(err => { logAndDispatchErrorForAction(`Update existing talent evaluation for user ${employeeId}`, err, dispatch, SAVE_TALENT_EVALUATION_ERROR, callback) });
  }
}

export function fetchTalentEvaluationsForEmployee(employeeId, callback){
  console.log('fetching talent cards for user: ', employeeId);

  return dispatch => {

    dispatch({
      type: FETCH_TALENT_EVALUATIONS,
    });

    TalentEvaluationsRef().where('userId', '==', employeeId).orderBy('ratedOn', 'desc').get().then(docs => {
      const talentEvaluations = unwrapDocs(docs) || [];

      dispatch({
        type: FETCH_TALENT_EVALUATIONS_SUCCESS,
        payload: talentEvaluations
      });

      callIfFunction(callback, talentEvaluations);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch talent cards for user ${employeeId}`, err, dispatch, FETCH_TALENT_EVALUATIONS_ERROR, callback) });
  }
}



// WEBPACK FOOTER //
// ./src/actions/talentEvaluations.js